"use client";
import { useEffect, useRef } from "react";

interface VideoPlayerProps {
  src: string;
}

const VideoPlayer = ({ src }: VideoPlayerProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const isUnmountedRef = useRef(false); // 标记组件是否已卸载

  // 组件卸载时设置标志位
  useEffect(() => {
    return () => {
      isUnmountedRef.current = true;
    };
  }, [src]);

  // 处理播放逻辑（增加卸载检查）
  const handlePlay = () => {
    console.log(234);
    if (isUnmountedRef.current) return; // 已卸载则终止播放
    const video = videoRef.current;
    console.log(video);
    if (video && video.paused) {
      video.play().catch((err) => {
        console.error("视频播放失败:", err);
      });
    }
  };

  // 🔹 当 src 改变时重新加载视频
  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.load();
      video.currentTime = 0;
    }
  }, [src]);

  // 监听视频结束事件（保持原有逻辑）
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleEnded = () => {
      video.currentTime = 0;
      video.pause();
    };

    video.addEventListener("ended", handleEnded);
    return () => video.removeEventListener("ended", handleEnded);
  }, [src]);

  return (
    <div className="video-container">
      <video
        ref={videoRef}
        controls
        preload="metadata"
        style={{ width: "100%", cursor: "pointer" }}
      >
        <source src={src} type="video/mp4" />
        您的浏览器不支持 video 标签。
      </video>
    </div>
  );
};

export default VideoPlayer;
